import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStateService } from './auth-state.service';

export const authGuard: CanActivateFn = () => {
  const authState = inject(AuthStateService);
  const router = inject(Router);

  if (!authState.isLoggedIn()) return router.createUrlTree(['/login']);

  // First-login users must set their own password before entering the app
  if (authState.currentUser()?.first_login) return router.createUrlTree(['/set-password']);

  return true;
};
